import { TextField } from "@mui/material";
export const SuffixInput = ({ value, onChange }) => (
  <TextField
    id="witness-suffix-input"
    label="Sufijo (debajo de los testigos)"
    placeholder="Texto libre (debajo de los testigos)"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    size="small"
    fullWidth
    inputProps={{ maxLength: 200 }}
  />
);